import type { ActionTypeOption, StrategyTypeOption, TemplateOption } from '@/hooks/useStrategiesData';

/**
 * Mock strategy type options for demo mode
 */
export const mockStrategyTypeOptions: StrategyTypeOption[] = [
  { id: 1, code: 'standard', name: 'Standard' },
  { id: 2, code: 'intensive', name: 'Intensive' },
  { id: 3, code: 'vip', name: 'VIP' },
  { id: 4, code: 'high risk', name: 'High Risk' },
];

/**
 * Mock action type options for demo mode
 */
export const mockActionTypeOptions: ActionTypeOption[] = [
  { id: 1, code: 'email', name: 'Email' },
  { id: 2, code: 'phone_call', name: 'Phone Call' },
  { id: 5, code: 'escalation', name: 'Escalation' },
  { id: 6, code: 'account_action', name: 'Place On Stop' },
];

/**
 * Mock email template options for demo mode
 */
export const mockEmailTemplateOptions: TemplateOption[] = [
  { id: 1, name: 'Payment Reminder - Friendly' },
  { id: 2, name: 'Payment Reminder - Urgent' },
  { id: 3, name: 'Final Notice Before Collection' },
  { id: 4, name: 'Payment Confirmation Request' },
];
